import React, { Component } from 'react';
import { isEmpty } from '../../../../Common/Common';

export default class Table_Body extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<tbody>
				{/* Loop through every management point that tenant has access to */}
				{(this.props.points).map((point_id) => {
					let point_name = point_id;
					if (window.app.state.point_list[point_id] != null) point_name = window.app.state.point_list[point_id].name;

					if (this.props.bill_data.data[point_id] == null) { //if bill data is empty, display all 0
						return (
							<tr>
								<td className="table-body">{point_name}</td>

								{/* Weekdays */}
								{Object.keys(this.props.price_info.zone.weekday).map((zone) => {
									if (this.props.price_info.zone.weekday[zone].enable) {
										return (
											<td className="table-body" style={{ textAlign: 'right' }}>0</td>
										)
									}
								})}

								{/* Power Consumption */}
								{Object.keys(this.props.price_info.zone.holiday).map((zone) => {
									if (this.props.price_info.zone.holiday[zone].enable) {
										return (
											<td className="table-body" style={{ textAlign: 'right' }}>0</td>
										)
									}
								})}
							</tr>
						)
					} else {
						return (
							<tr>
								<td className="table-body">{point_name}</td>

								{/* Weekdays */}
								{Object.keys(this.props.bill_data.data[point_id].weekday).map((zone) => {
									if (!isEmpty(this.props.price_info.zone.weekday[zone])) {
										if (this.props.price_info.zone.weekday[zone].enable) {
											return (
												<td className="table-body" style={{ textAlign: 'right' }}>{this.props.bill_data.data[point_id].weekday[zone][0]}</td>
											)
										}
									}
								})}

								{/* Power Consumption */}
								{Object.keys(this.props.bill_data.data[point_id].holiday).map((zone) => {
									if (!isEmpty(this.props.price_info.zone.holiday[zone])) {
										if (this.props.price_info.zone.holiday[zone].enable) {
											return (
												<td className="table-body" style={{ textAlign: 'right' }}>{this.props.bill_data.data[point_id].holiday[zone][0]}</td>
											)
										}
									}
								})}

							</tr>
						)
					}
				})}
			</tbody>
		)
	}
}